@if ({
  isActived: isActived$ | async,
  }; as content) {
  <button class="container-hamburguer" [ngClass]="{ active: content.isActived }" (click)="toggleStatus()">
    <span></span>
    <span></span>
    <span></span>
  </button>
}
